import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "manage-notes" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M9.57 5.93018L3.5 12.0002L9.57 18.0702M20.5 12.0002H3.67",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Gerenciar notas", -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = {
  class: "search",
  for: "search-note"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("path", {
  d: "M17.5002 17.5002L13.881 13.881M13.881 13.881C14.5001 13.2619 14.9912 12.527 15.3262 11.7181C15.6612 10.9093 15.8337 10.0423 15.8337 9.16684C15.8337 8.29134 15.6612 7.42441 15.3262 6.61555C14.9912 5.80669 14.5001 5.07174 13.881 4.45267C13.2619 3.8336 12.527 3.34252 11.7181 3.00748C10.9093 2.67244 10.0423 2.5 9.16684 2.5C8.29134 2.5 7.42441 2.67244 6.61555 3.00748C5.80669 3.34252 5.07174 3.8336 4.45267 4.45267C3.2024 5.70295 2.5 7.39868 2.5 9.16684C2.5 10.935 3.2024 12.6307 4.45267 13.881C5.70295 15.1313 7.39868 15.8337 9.16684 15.8337C10.935 15.8337 12.6307 15.1313 13.881 13.881Z",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("path", {
  d: "M4 4L16 16",
  stroke: "#079F72",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("path", {
  d: "M16 4L4 16",
  stroke: "#079F72",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { class: "card-top" }
const _hoisted_12 = { class: "card-bottom" }
const _hoisted_13 = { class: "card-description" }
const _hoisted_14 = { class: "card-footer" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "card-icons" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "none",
    d: "M13.2594 3.59924L5.04936 12.2892C4.73936 12.6192 4.43936 13.2692 4.37936 13.7192L4.00936 16.9592C3.87936 18.1292 4.71936 18.9292 5.87936 18.7292L9.09936 18.1792C9.54936 18.0992 10.1794 17.7692 10.4894 17.4292L18.6994 8.73924C20.1194 7.23924 20.7594 5.52924 18.5494 3.43924C16.3494 1.36924 14.6794 2.09924 13.2594 3.59924Z",
    "stroke-width": "1.5",
    "stroke-miterlimit": "10",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11.89 5.05078C12.0996 6.39164 12.7486 7.62492 13.735 8.55703C14.7214 9.48914 15.9894 10.0673 17.34 10.2008M3 22.0008H21",
    "stroke-width": "1.5",
    "stroke-miterlimit": "10",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "none",
    d: "M21 5.98C17.67 5.65 14.32 5.48 10.98 5.48C9 5.48 7.02 5.58 5.04 5.78L3 5.98M8.5 4.97L8.72 3.66C8.88 2.71 9 2 10.69 2H13.31C15 2 15.13 2.75 15.28 3.67L15.5 4.97M18.85 9.14L18.2 19.21C18.09 20.78 18 22 15.21 22H8.79C6 22 5.91 20.78 5.8 19.21L5.15 9.14M10.33 16.5H13.66M9.5 12.5H14.5",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = {
  key: 1,
  class: "no-options"
}
const _hoisted_24 = /*#__PURE__*/_createStaticVNode("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"173\" height=\"173\" viewBox=\"0 0 24 24\" fill=\"none\"><path opacity=\"0.4\" d=\"M16 4.02002C19.33 4.20002 21 5.43002 21 10V16C21 20 20 22 15 22H9C4 22 3 20 3 16V10C3 5.44002 4.67 4.20002 8 4.02002\" stroke=\"#292D32\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M9 13H15\" stroke=\"#292D32\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M9 16H12.5\" stroke=\"#292D32\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M10 6H14C15 6 15 5 15 4C15 2 14.5 2 14 2H10C9.5 2 9 2 9 4C9 6 9.5 6 10 6Z\" stroke=\"#292D32\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg><h1>Sem notas para gerenciar no momento</h1>", 2)
const _hoisted_26 = { class: "note-detail" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("h1", null, "Detalhes da nota", -1)
const _hoisted_28 = ["innerHTML"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "52",
  height: "52",
  viewBox: "0 0 52 52",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M42.2722 12.6747L29.4021 5.24301C27.3005 4.02967 24.7005 4.02967 22.5771 5.24301L9.72881 12.6747C7.62715 13.888 6.32715 16.1413 6.32715 18.5897V33.4097C6.32715 35.8363 7.62715 38.0897 9.72881 39.3247L22.5988 46.7563C24.7005 47.9697 27.3005 47.9697 29.4238 46.7563L42.2938 39.3247C44.3955 38.1113 45.6955 35.858 45.6955 33.4097V18.5897C45.6738 16.1413 44.3738 13.9097 42.2722 12.6747ZM24.3755 16.7913C24.3755 15.903 25.1121 15.1663 26.0005 15.1663C26.8888 15.1663 27.6255 15.903 27.6255 16.7913V28.1663C27.6255 29.0547 26.8888 29.7913 26.0005 29.7913C25.1121 29.7913 24.3755 29.0547 24.3755 28.1663V16.7913ZM27.9938 36.0313C27.8855 36.2913 27.7338 36.5297 27.5388 36.7463C27.1271 37.158 26.5855 37.3747 26.0005 37.3747C25.7188 37.3747 25.4371 37.3097 25.1771 37.2013C24.8955 37.093 24.6788 36.9413 24.4621 36.7463C24.2671 36.5297 24.1155 36.2913 23.9855 36.0313C23.8771 35.7713 23.8338 35.4897 23.8338 35.208C23.8338 34.6447 24.0505 34.0813 24.4621 33.6697C24.6788 33.4747 24.8955 33.323 25.1771 33.2147C25.9788 32.868 26.9321 33.063 27.5388 33.6697C27.7338 33.8863 27.8855 34.103 27.9938 34.3847C28.1021 34.6447 28.1671 34.9263 28.1671 35.208C28.1671 35.4897 28.1021 35.7713 27.9938 36.0313Z",
    fill: "#A30711"
  })
], -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("h1", null, "Cuidado!", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("h2", null, "Deseja mesmo remover essa nota?", -1)

import { onMounted, ref } from 'vue'
import { useAxios } from '@/api/axios'
import NoteModel from '@/models/NoteModel'
import NoteStatusEnum from '@/enums/NoteStatusEnum'
import { AxiosResponse } from 'axios'
import SpinnerLoader from '@/components/loader/SpinnerLoader.vue'
import MyModal from '@/components/modal/MyModal.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ManageNotesView',
  setup(__props) {

const axios = useAxios()
const notes = ref<NoteModel[]>()
const filter = ref<Record<string, string>>({ status: NoteStatusEnum.ACTIVE })
const isConfirmDeleteModal = ref(false)
const noteToDeleteId = ref(0)
const isDetailModalOpen = ref(false)
const selectedNote = ref<NoteModel | null>(null)

function stripHtml (html: string | null): string {
  if (!html) return ''
  return html.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim()
}

function openNote (note: NoteModel): void {
  selectedNote.value = note
  isDetailModalOpen.value = true
}

function getNotes (): void {
  notes.value = undefined
  const params: Record<string, string> = {}
  if (filter.value.search) params.search = filter.value.search

  axios.get('/api/notes', { params })
    .then((res: AxiosResponse<NoteModel[]>) => {
      notes.value = res.data
    })
}

function deleteNote (id: number): void {
  notes.value = notes.value?.filter(n => n.id !== id)
  const notesValue = notes.value
  notes.value = undefined

  const formData = new FormData()
  formData.append('note_ids[]', String(id))

  axios.delete('/api/notes', formData)
    .then(() => {
      notes.value = notesValue
    })
    .catch(() => getNotes())
}

onMounted(() => {
  getNotes()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/admin/home'))),
      class: "back"
    }, _hoisted_4),
    _createElementVNode("label", _hoisted_5, [
      _withDirectives(_createElementVNode("input", {
        autocomplete: "off",
        type: "text",
        placeholder: "Digite o titulo da nota para buscar",
        id: "search-note",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filter.value.search) = $event)),
        onKeydown: _cache[2] || (_cache[2] = _withKeys(($event: any) => (getNotes()), ["enter"]))
      }, null, 544), [
        [_vModelText, filter.value.search]
      ]),
      (!filter.value.search)
        ? (_openBlock(), _createElementBlock("svg", {
            key: 0,
            onClick: _cache[3] || (_cache[3] = ($event: any) => (getNotes())),
            xmlns: "http://www.w3.org/2000/svg",
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "none"
          }, _hoisted_7))
        : (_openBlock(), _createElementBlock("svg", {
            key: 1,
            onClick: _cache[4] || (_cache[4] = ($event: any) => {filter.value.search = ''; getNotes();}),
            xmlns: "http://www.w3.org/2000/svg",
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "none"
          }, _hoisted_10))
    ]),
    (notes.value && notes.value.length)
      ? (_openBlock(), _createBlock(_TransitionGroup, {
          key: 0,
          tag: "div",
          name: "note-card",
          class: "notes-grid"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notes.value, (note) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "note-card",
                key: note.id
              }, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("h2", null, _toDisplayString(note.title), 1)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("p", _hoisted_13, _toDisplayString(stripHtml(note.description)), 1),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("button", {
                      class: "open-btn",
                      onClick: ($event: any) => (openNote(note))
                    }, "abrir nota", 8, _hoisted_15),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("button", {
                        onClick: ($event: any) => (_ctx.$router.push({ name: 'admin.notes.edit', params: { id: note.id } }))
                      }, _hoisted_19, 8, _hoisted_17),
                      _createElementVNode("button", {
                        onClick: ($event: any) => {isConfirmDeleteModal.value = true; noteToDeleteId.value = note.id}
                      }, _hoisted_22, 8, _hoisted_20)
                    ])
                  ])
                ])
              ]))
            }), 128))
          ]),
          _: 1
        }))
      : (notes.value && !notes.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _hoisted_24,
            _createElementVNode("p", null, [
              _createElementVNode("a", {
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.push('/admin/create-notes')))
              }, "Clique aqui"),
              _createTextVNode(" para cadastrar")
            ])
          ]))
        : (_openBlock(), _createBlock(SpinnerLoader, { key: 2 })),
    _createVNode(MyModal, {
      width: '620px !important',
      height: '560px !important',
      isOpen: isDetailModalOpen.value,
      "class-name": 'note-detail-modal',
      toggleModal: (v) => isDetailModalOpen.value = v,
      zIndex: 100
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _createElementVNode("div", {
            class: "note-detail__content",
            innerHTML: selectedNote.value?.description
          }, null, 8, _hoisted_28)
        ])
      ]),
      _: 1
    }, 8, ["isOpen", "toggleModal"]),
    _createVNode(MyModal, {
      width: '330px !important',
      height: '260px !important',
      isOpen: isConfirmDeleteModal.value,
      "class-name": 'confirm-delete',
      toggleModal: (v) => isConfirmDeleteModal.value = v,
      zIndex: 100
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _hoisted_29,
          _hoisted_30,
          _hoisted_31,
          _createElementVNode("section", null, [
            _createElementVNode("button", {
              onClick: _cache[6] || (_cache[6] = ($event: any) => {isConfirmDeleteModal.value = false; deleteNote(noteToDeleteId.value)})
            }, "Sim"),
            _createElementVNode("input", {
              onClick: _cache[7] || (_cache[7] = ($event: any) => (isConfirmDeleteModal.value = false)),
              type: "button",
              value: "Cancelar"
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["isOpen", "toggleModal"])
  ]))
}
}

})